import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/termeni" element={<Legal />} />
              <Route path="/confidentialitate" element={<Legal />} />
              <Route path="/cookies" element={<Legal />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
